import './index.scss'
import classNames from 'classnames'
import {useSelector} from 'react-redux'

const ContentLoader = ({width, height, className}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    return (
        <div className={classNames({
            'content-loader': true,
            [className]: className,
            'dark': isDarkMode
        })}>
            <svg width={width || "156"} height={height || "156"} viewBox="0 0 156 156" fill="none" xmlns="http://www.w3.org/2000/svg">
                <ellipse cx="76.9126" cy="78" rx="56.2232" ry="57.0181" stroke="#1681FF" stroke-opacity="0.25" stroke-width="14"/>
                <path d="M76.5224 20.9834C91.4333 20.8787 105.775 26.7854 116.391 37.404C127.008 48.0227 133.03 62.4836 133.133 77.6053" stroke="url(#paint0_linear_2994_6448)" stroke-width="14" stroke-linecap="round" stroke-dasharray="4 4"/>
                <defs>
                    <linearGradient id="paint0_linear_2994_6448" x1="125.449" y1="106.776" x2="27.6844" y2="50.4203" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#1681FF"/>
                        <stop offset="0.755208" stop-color="#1681FF" stop-opacity="0.01"/>
                        <stop offset="1" stop-color="#1681FF" stop-opacity="0"/>
                    </linearGradient>
                </defs>
            </svg>
        </div>
    )
}

export default ContentLoader
